import { render, staticRenderFns } from "./kpi-hand-punish.vue?vue&type=template&id=51edcbc4"
import script from "./kpi-hand-punish.vue?vue&type=script&lang=js"
export * from "./kpi-hand-punish.vue?vue&type=script&lang=js"
import style0 from "./kpi-hand-punish.vue?vue&type=style&index=0&id=51edcbc4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports